export default __webpack_public_path__ + "static/media/5.34153865.jpg";